/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Kpi_SatisfactionInputs */



/**
* | output |
* | --- |
* | "Satisfaction rate" |
*
* @param {Feedback_Kpi_SatisfactionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const feedback_kpi_satisfaction = /** @type {((inputs?: Feedback_Kpi_SatisfactionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Kpi_SatisfactionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zufriedenheitsquote")
	return /** @type {LocalizedString} */ ("Satisfaction rate")
});